import { NgTemplateOutlet } from "@angular/common";
import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InfoPopoverComponent } from "@kno2/shared/info-popover";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { FloatLabel } from "primeng/floatlabel";
import { InputText } from "primeng/inputtext";
import { FormControlBaseDirective } from "../form-control-base.directive";

let nextId = 0;

@Component({
    selector: "kno2-form-input",
    imports: [FormsModule, InputText, NgxMaskDirective, FloatLabel, NgTemplateOutlet, InfoPopoverComponent],
    templateUrl: "./form-input.component.html",
    providers: [provideNgxMask()],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInputComponent extends FormControlBaseDirective {
    public readonly type = input<string>("text");
    public readonly placeholder = input<string>();
    public readonly inputId = input<string>(`kno2-form-input-${nextId++}`);
    public readonly readonly = input<boolean, unknown>(false, { transform: booleanAttribute });
    public readonly size = input<"small" | "large">();
    public readonly maxlength = input<number>();
    public readonly pattern = input<string>();
    public readonly mask = input<string>();
    public readonly dropSpecialCharacters = input<boolean, unknown>(true, { transform: booleanAttribute });
    public readonly displayValue = input<string | null>();

    protected readonly value = signal<unknown>(null);
    protected readonly displayedValue = computed(() => this.displayValue() ?? this.value());
    protected readonly isReadonly = computed(() => this.readonly() || this.displayValue() != null);

    protected applyValue(value: unknown): void {
        this.value.set(value);
    }

    protected handleChange(value: unknown): void {
        this.value.set(value);
        this.emitChange(value);
    }
}
